<div class="formulario-array-row" *ngFor="let rangoSeleccion of valoresFormulariosArray; let i=index;">
    <div class="popup-form-campo">
        <neo-formulario [id]="'formularioArray_' + i + '_'" [aplicarFlex]="aplicarFlex"
            [identificador]="'formularioArray_' + i + '_'" [formularioAncho]="clasesFormularioAnchoEnum"
            [camposFormulario]="inputsFormularioArr[i]" [valoresIniciales]="rangoSeleccion"
            (changeValueForm)="onCambioFormulario($event, i, 'formularioArray_' + i + '_')"></neo-formulario>
    </div>
    <div class="popup-form-btn" *ngIf="permitirEliminar">
        <neo-button [ngClass]="''" [flat]="true" [color]="''" [iconClass]="'icon-20 icon-ibm--trash-can text-danger'"
            [clase]="'btn-cuadrado mt-campo'" (accion)="onClickEliminar(i, 'formularioArray_' + i + '_')">
        </neo-button>
    </div>
</div>
<div class="formulario-array-row" *ngIf="permitirAnhadir">
    <div class="popup-form-campo">
        <neo-formulario #formularioSemillaArray [identificador]="'formularioSemillaArray'" [aplicarFlex]="aplicarFlex"
            [formularioAncho]="clasesFormularioAnchoEnum" [camposFormulario]="inputsFormulario" [valoresIniciales]="[]">
        </neo-formulario>
    </div>
    <div class="popup-form-btn">
        <neo-button [ngClass]="''" [flat]="true" [color]="colorBotonAnhadir" [iconClass]="'icon-20 icon-ibm--add'"
            [clase]="'btn-cuadrado mt-campo'" (accion)="onClickAnhadir()"></neo-button>
    </div>
</div>